import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createFsCacheProxy } from '@segment/utils/fsCache';
var keys = ["customer-metaData"];
export var fetchMetaData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var enabled, fetchWithCache, data, metaData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 3;
            return createFsCacheProxy(keys, function () {
              return client.get("/content/rawEntries/customerStories");
            }, {
              enabled: enabled
            });

          case 3:
            fetchWithCache = _context.sent;
            _context.next = 6;
            return fetchWithCache();

          case 6:
            data = _context.sent;
            metaData = data.items.filter(function (item) {
              return item.sys.id === "3nUzEZIwvUXU7SRyMGBYRa";
            }).map(function (value) {
              return {
                socialTitle: value.fields.socialTitle,
                socialDescription: value.fields.socialDescription,
                socialImage: value.fields.socialImage
              };
            });
            return _context.abrupt("return", metaData[0]);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchMetaData(_x) {
    return _ref.apply(this, arguments);
  };
}();